import * as Yup from 'yup';

export const validationSchemaDeal = Yup.object().shape({
  name: Yup.string().required('Opportunity Name is required'),
  // .test(
  //   "is-valid-Opportunity-Name",
  //   "Opportunity Name should only contain alphabets",
  //   (value) => !value || /^[A-Za-z\s]+$/.test(value)
  // ),

  accountId: Yup.string().required('Account Name is required'),

  contactId: Yup.string()
    .required('Contact Name is required')
    .trim()
    .max(50, 'Contact Name must not exceed 50 characters')
    .test(
      'valid-format',
      'Please enter valid name',
      (value) =>
        !value ||
        (/^[A-Za-z0-9\s\-']+$/.test(value) && // Only alphabets, numbers and allowed special chars
          !/(\s{2,}|-{2,}|'{2,})/.test(value) && // No consecutive spaces or special chars
          !/^[-'\s]|[-'\s]$/.test(value)) // No leading/trailing special chars
    ),

  stageId: Yup.string().required('Stage is required'),

  industryId: Yup.string().required('Industry is required'),

  leadSourceId: Yup.string().required('Lead Source is required'),

  sourceName: Yup.string().required('Source Name is required'),
  // .test(
  //   "is-valid-Source-Name",
  //   "Source Name should only contain alphabets",
  //   (value) => !value || /^[A-Za-z\s]+$/.test(value)
  // ),
  // otherSourceName: Yup.string()
  // .required('Source Name is required').test(
  //   "is-valid-Source-Name",
  //   "Source Name should only contain alphabets",
  //   (value) => !value || /^[A-Za-z\s]+$/.test(value)
  // ),

  nextStep: Yup.string().required('Next Step is required'),
  // .test(
  //   "is-valid-Next-Step",
  //   "Next Step should only contain alphabets",
  //   (value) => !value || /^[A-Za-z\s]+$/.test(value)
  // ),

  city: Yup.string()
    .nullable()
    .trim() // Automatically trim leading and trailing spaces
    .max(50, 'City cannot exceed 50 characters.')
    .test('valid-characters', 'Please enter valid city', (value) => {
      if (!value) return true; // Allow blank input
      return /^[A-Za-z\s'-.]+$/.test(value);
    }),

  state: Yup.string()
    .nullable()
    .test('is-alphabet-only', 'State should only contain alphabets', (value) => {
      if (!value) return true; // Allow blank input
      return /^[A-Za-z\s]+$/.test(value); // Only alphabets if not blank
    }),

  country: Yup.string()
    .nullable()
    .trim()
    .test('valid-country', 'Country should only contain alphabets and hyphens', (value) => {
      if (!value) return true; // Allow blank input
      // Allow alphabets, spaces and single hyphens
      return (
        /^[A-Za-z\s-]+$/.test(value) && // Only alphabets, spaces and hyphens
        !/--/.test(value) && // No consecutive hyphens
        !/^-|-$/.test(value)
      ); // No leading/trailing hyphens
    }),

  zipCode: Yup.string()
    .nullable()
    .trim()
    .test(
      'is-valid-zip-code',
      'ZIP code must be 3-10 characters with only letters, numbers and hyphens',
      (value) => {
        if (!value) return true; // Allow empty value

        // Check for valid characters and length
        return (
          /^[A-Za-z0-9-]{3,10}$/.test(value) && // Only letters, numbers, hyphen
          !/--/.test(value)
        ); // No consecutive hyphens
      }
    ),

  businessType: Yup.string().nullable(),
  // .test(
  //   "is-valid-business-type",
  //   "Business Type should only contain alphabets",
  //   (value) => !value || /^[A-Za-z\s]+$/.test(value)
  // ),
  lineOfBusiness: Yup.string().nullable(),
  // .test(
  //   "is-valid-lineOfBusiness",
  //   "Line Of Business should only contain alphabets",
  //   (value) => !value || /^[A-Za-z\s&,|]+$/.test(value)
  // ),

  amount: Yup.string()
    .nullable()
    .test(
      'is-valid-amount',
      // "Please enter a valid amount",
      (value) => {
        if (!value) return true; // Allow empty value

        // Check if value contains only numbers and at most one decimal point
        const hasOnlyValidChars = /^[0-9.]+$/.test(value);
        const decimalPoints = (value.match(/\./g) || []).length;

        return hasOnlyValidChars && decimalPoints <= 1;
      }
    )
    .test('no-leading-decimal', 'Amount cannot start with a decimal point', (value) => {
      if (!value) return true;
      return !value.startsWith('.');
    })
    .test('decimal-places', 'Amount cannot have more than 2 decimal places', (value) => {
      if (!value) return true;
      const parts = value.split('.');
      return parts.length === 1 || parts[1].length <= 2;
    }),

  probability: Yup.string()
    .nullable()
    .test({
      name: 'is-valid-amount',
      message: 'Enter a valid amount',
      test: (value) => {
        if (!value) return true; // Allow empty value

        // Check if value contains only numbers and at most one decimal point
        const hasOnlyValidChars = /^[0-9.]+$/.test(value);
        const decimalPoints = (value.match(/\./g) || []).length;

        return hasOnlyValidChars && decimalPoints <= 1;
      },
    })
    .test({
      name: 'no-leading-decimal',
      message: 'Enter a valid amount',
      test: (value) => {
        if (!value) return true;
        return !value.startsWith('.');
      },
    })
    .test({
      name: 'decimal-places',
      message: 'Enter a valid amount',
      test: (value) => {
        if (!value) return true;
        const parts = value.split('.');
        return parts.length === 1 || parts[1].length <= 2;
      },
    })
    .test({
      name: 'max-probability',
      message: 'Probability cannot be greater than 100%',
      test: (value) => {
        if (!value) return true;
        const numValue = parseFloat(value);
        return !isNaN(numValue) && numValue <= 100;
      },
    }),

  expectedRevenue: Yup.string()
    .nullable()
    .test({
      name: 'is-valid-amount',
      message: 'Enter a valid amount',
      test: (value) => {
        if (!value) return true; // Allow empty value

        // Check if value contains only numbers and at most one decimal point
        const hasOnlyValidChars = /^[0-9.]+$/.test(value);
        const decimalPoints = (value.match(/\./g) || []).length;

        return hasOnlyValidChars && decimalPoints <= 1;
      },
    })
    .test({
      name: 'no-leading-decimal',
      message: 'Enter a valid amount',
      test: (value) => {
        if (!value) return true;
        return !value.startsWith('.');
      },
    })
    .test({
      name: 'decimal-places',
      message: 'Enter a valid amount',
      test: (value) => {
        if (!value) return true;
        const parts = value.split('.');
        return parts.length === 1 || parts[1].length <= 2;
      },
    }),
});
